import { TalentCertificateDocument } from "../../../talents/talentAPI";
import { WorkPermitDocumentComponent } from "./WorkPermitDocument";

type Props = {
  documents: (File | TalentCertificateDocument)[];
  onChange: (files: (File | TalentCertificateDocument)[]) => void;
  handleRemoveDocument: (document: TalentCertificateDocument) => void;
  handleEditDocument?: (document: TalentCertificateDocument | File) => void;
};

const WorkPermitDocumentList = ({
  documents,
  onChange,
  handleRemoveDocument,
  handleEditDocument,
}: Props) => {
  const removeDocument = (
    document: TalentCertificateDocument | File,
    index: number,
  ) => {
    const updatedFiles = documents.filter((_, ind) => ind !== index);
    if (document instanceof File) {
      // new documents, not yet uploaded files
      return onChange(updatedFiles);
    }
    // existing documents
    handleRemoveDocument(document);
    return onChange(updatedFiles);
  };

  return (
    <>
      {documents.map((document, index) => (
        <WorkPermitDocumentComponent
          key={index}
          document={document}
          index={index}
          removeDocument={removeDocument}
          handleEditDocument={handleEditDocument}
        />
      ))}
    </>
  );
};

export default WorkPermitDocumentList;
